export const STORAGE_KEYS = {
    ACCOUNT_INFO: 'account_info',
    MICROSOFT_TOKEN: 'microsoft_token',
    MICROSOFT_ID_TOKEN: 'microsoft_id_token',
    GROM_TOKEN: 'grom_token',
    USER_INFO: 'user_info',
    APP_LOGS: 'app_logs_v1',
    APP_LOGS_SETTINGS: 'app_logs_settings_v1',
    UNAUTHORIZE_RETURN_PATH: 'unauthorize_return_path',
} as const;

// Make the type more strict
export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];

// Create a readonly version of the keys
export const READONLY_STORAGE_KEYS: Readonly<typeof STORAGE_KEYS> = Object.freeze(STORAGE_KEYS); 